import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Link } from 'react-router-dom';
import { withRouter } from "react-router-dom";

//import ButtonDialogClose from '../../elements/button-dialog-close';

const NavigationMobile = inject("stores") (
    observer (
        class NavigationMobile extends Component {

            constructor(props) {
                super(props);
                this.props = props;
                this.storeUi = this.props.stores.storeUi;
            }

            componentDidMount = () => {
                console.log('SbC is active::', this.storeUi.nav_mobile )
            }
            
            componentDidUpdate = (prevProps) => {
                console.log('SbC is active::', this.storeUi.nav_mobile )
                if (prevProps.is_active !== this.props.is_active) {
                    console.log('SbC is active::', this.storeUi.nav_mobile )
                }
            }

            handleClose = (e) => {
                this.storeUi.setNavMobile();
            }

            handleNavClick = (e, id, path) => {
                // this.handleClose();
                // this.storeUi.setActiveMainNav(id);
                // this.props.history.push(path);
            }

            render() {
                return (
                    <div className={"navigation--mobile" + (this.storeUi.nav_mobile ? " --active" : "")}>
                        {/* <ButtonDialogClose
                            caption = {'Sluit'}
                            onAction = {(e) => this.handleClose(e)}
                            btnClass = {'icon--close'}
                        /> */}
                        <div className="navigation--mobile__content">
                            mobile
                        </div>
                    </div>
                )
            }
        }
    )
)

export default withRouter(NavigationMobile);
